// The string used in the URLs, in place of a project slug
// or token (in the case of reports generation), which should trigger the use of fake data
// that is safe to showcase to clients
export const SHOWCASE_IDENTIFIER = 'showcase';
export const FR_PROJECT_IDENTIFIER = 'drawbotics_project_fr';
export const EN_PROJECT_IDENTIFIER = 'drawbotics_project_en';
